import { combineReducers } from "@reduxjs/toolkit";
import { MAIN_INITIAL_STATE, mainReducer } from "./MainReducer";
import { PRINT_INITIAL_STATE, printReducer } from "./PrintReducer";
import { createPagesReducer } from "./CreatePagesReducer";
import { manipulateExercisesReducer } from "./ManipulateExercisesReducer";
import { manipulateObjectivesReducer } from "./ManipulateObjectivesReducer";

export const INITIAL_EXAM_STATE = {
  main: MAIN_INITIAL_STATE,
  print: PRINT_INITIAL_STATE,
};

const examBuilderReducer = combineReducers({
  main: mainReducer,
  createPages: createPagesReducer,
  print: printReducer,
  manipulateExercises: manipulateExercisesReducer,
  manipulateObjectives: manipulateObjectivesReducer,
});

export default examBuilderReducer;
